import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="form"
export default class extends Controller {
  static targets = ['disable', 'focus', 'token'];

  focus() {
    if (this.hasFocusTarget) {
      this.focusTarget.focus();
    }
  }

  focusTargetConnected(target) {
    target.focus();
  }

  // Define a "trim" parameter with value "true" (using [data-form-trim-param="true"]) to trim the value of the field
  // that caused the event beforehand.
  submit({ params, target }) {
    if (params.trim) {
      target.value = target.value.trim();
    }
    this.element.requestSubmit();
  }

  disableSubmit() {
    this.disableTargets.forEach((target) => {
      target.disabled = true;
    });
  }

  tokenTargetConnected(target) {
    fetch('/token', { credentials: 'same-origin' }).then((response) => response.text()).then((data) => {
      if (data !== '') {
        target.value = data;
        this.element.querySelector('button[disabled][type="submit"]').toggleAttribute('disabled');
      }
    });
  }
};
